import {connect} from "react-redux";
import CheckoutPage from "./CheckoutPage";
import * as AccountApiActions from "../actions/AccountApiActions";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";


export default connect(null, {...ViewActions, ...AccountApiActions})(withRouter(CheckoutPage));